import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { toast } from 'react-toastify';
import ItemTable from './ReceiptUtils/ItemTable';
import { PanelBottomClose, PanelLeftClose, PanelTopClose, PanelTopCloseIcon, X } from 'lucide-react';
import { decryptToken } from './utils/getToken';
import { customerFinanceKey } from './CustomerDetails/customerFinance';
import { PAYMENT_METHODS } from '../utils/paymentMethods';

const REFERENCE_HINTS = {
  upi: "UPI transaction / UTR reference",
  card: "Last 4 digits or auth code",
  bank_transfer: "NEFT / IMPS / RTGS reference",
  cheque: "Cheque number",
  cash: "Optional note",
  other: "Transaction ID or note",
};

function describeReceiptDelivery(delivery) {
  if (!delivery) return { message: null, type: "success" };
  const parts = [];
  let hasError = false;
  let hasWarning = false;
  if (delivery.email?.sent) parts.push("email sent");
  else if (delivery.email?.reason === "no_customer_email") {
    parts.push("email skipped (no customer email)");
    hasWarning = true;
  } else if (delivery.email?.reason === "no_smtp") {
    parts.push("email failed (SMTP not configured)");
    hasError = true;
  } else if (delivery.email?.reason === "smtp_error") {
    parts.push(`email failed (${delivery.email.error || "SMTP error"})`);
    hasError = true;
  }
  if (delivery.whatsapp?.sent) parts.push("WhatsApp sent");
  else if (delivery.whatsapp?.reason === "invalid_phone") {
    parts.push("WhatsApp skipped (invalid phone)");
    hasWarning = true;
  } else if (delivery.whatsapp?.reason === "skipped") {
    parts.push("WhatsApp skipped (not configured)");
    hasWarning = true;
  } else if (delivery.whatsapp?.error) {
    parts.push(`WhatsApp failed (${delivery.whatsapp.error})`);
    hasError = true;
  }
  if (delivery.error) {
    hasError = true;
    parts.push(delivery.error);
  }
  const type = hasError ? "error" : hasWarning ? "warning" : "success";
  return { message: parts.length ? parts.join("; ") : null, type };
}

const ReceiptModal = ({ isOpen, setIsOpen, editData = null, prefillReceipt = null, fetchReceipts, fetchInvoices, routeCustomerId }) => {
  const [formData, setFormData] = useState({
    customerName: '',
    invoiceNumber: '',
    amount: '',
    receiptDate: '',
    customerId: '',
    order_number: "",
    invoice_Number: "",
    sendMail: true,
    invoice_date: "",
    payment_method: "upi",
    payment_reference: "",
  });
  const [taxAmountTotal, setTaxAmountTotal] = useState()
  const [discountAmountTotal, setDisountamountTotal] = useState()
  const url = API_BASE_URL;
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [amountError, setAmountError] = useState('');
  const [sendWhatsapp, setSendWhatsapp] = useState(false);
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const [invoiceDataget, setInvoiceData] = useState([])
  const [openInvoice, setOpenInvoice] = useState(false);
  const [items, setItems] = useState([
    {
      id: 1, item: null, quantity: "", rate: "", discount: "", tax: "", discount_amount: 0, hsn: "",
      tax_amount: 0
    },
  ]);
  const token = decryptToken("accessToken") || ""
  const invoicePrefix = "INVE";
  const [shipping, setShipping] = useState(0);
  const [subtotal, setSubtotal] = useState("");
  const [advance_payment, setAdvancePayment] = useState(0);
  const [itemsOptions, setItemsOptions] = useState([]);
  const [load, setLoad] = useState(false);


  const [selectedInvoice, setSelectedInvoice] = useState(null); // store selected invoice
  const [selectedInvoiceMain, setSelectedInvoiceMain] = useState(null); // store selected invoice

  useEffect(() => {
    if (!isOpen) return;

    setOpenInvoice(false);
    setAmountError('');
    setSelectedInvoice(null);
    setSelectedInvoiceMain(null);

    const fetchCustomers = async () => {
      try {
        const user = getDecryptedUserFromCookie("gta_mainstateuser");
        const res = await fetch(`${url}/api/customer/all/${user.main_id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        const data = await res.json();

        const formatted = data.map((cust) => ({
          value: customerFinanceKey(cust),
          label: `${cust.customerName} - ${customerFinanceKey(cust)}`,
          name: cust.customerName
        }));
        setCustomerOptions(formatted);


        // 🛠 Set form data after setting options
        if (editData) {
          setFormData({
            customerName: editData.customerName || '',
            invoiceNumber: editData.invoiceNumber || '',
            amount: editData.amount || '',
            receiptDate: editData.receiptDate || '',
            customerId: editData.customerId || '',
            sendMail: editData.sendMail ?? true,
            payment_method: editData.payment_method || 'upi',
            payment_reference: editData.payment_reference || '',
          });
          setSendWhatsapp(Boolean(editData.sendWhatsapp));
          await fetchInvoicesByCustomer(editData.customerId);
          await fetchInvoicesForAllCustomer(editData.customerId);



        } else if (prefillReceipt?.customerId) {
          const today = new Date().toLocaleDateString('en-CA');
          const customerId = prefillReceipt.customerId;
          const opt = formatted.find((o) => String(o.value) === String(customerId));
          setFormData({
            customerName: opt ? opt.label : (prefillReceipt.customerName || ''),
            invoiceNumber: prefillReceipt.invoiceNumber || '',
            amount:
              prefillReceipt.amount != null && prefillReceipt.amount !== ''
                ? String(prefillReceipt.amount)
                : '',
            receiptDate: prefillReceipt.receiptDate || today,
            customerId,
            sendMail: true,
            payment_method: "upi",
            payment_reference: "",
          });
          await fetchInvoicesByCustomer(customerId);
          await fetchInvoicesForAllCustomer(customerId);
        } else if (routeCustomerId) {
          const opt = formatted.find((o) => String(o.value) === String(routeCustomerId));
          setFormData({
            customerName: opt ? `${opt.name} - ${opt.value}` : '',
            invoiceNumber: '',
            amount: '',
            receiptDate: '',
            customerId: opt ? opt.value : routeCustomerId,
            sendMail: true,
            payment_method: "upi",
            payment_reference: "",
          });
          if (opt) {
            await fetchInvoicesByCustomer(opt.value);
            await fetchInvoicesForAllCustomer(opt.value);
          }
        } else {
          setFormData({
            customerName: '',
            invoiceNumber: '',
            amount: '',
            receiptDate: '',
            customerId: '',
            sendMail: true,
            payment_method: "upi",
            payment_reference: "",
          });
        }
      } catch (err) {
        console.error('Failed to fetch customers:', err);
      }
    };

    fetchCustomers();
  }, [isOpen, editData, routeCustomerId, prefillReceipt]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (load) return;

    if (!openInvoice && amountError) {
      toast.error(amountError);
      return;
    }

    setLoad(true);
    if (openInvoice) {
      const user = getDecryptedUserFromCookie("gta_mainstateuser");
      const today = new Date().toLocaleDateString('en-CA');
      const payloadMain = {
        ...formData,
        amount: subtotal,
        invoice_number: `${formData.invoice_Number}`,
        invoiceNumber: `${formData.invoice_Number}`,
        subtotal: subtotal,
        openInvoice: openInvoice,
        items: items.map(row => ({
          id: row.id,
          item: row.item, // full object
          hsn: row.hsn,
          quantity: row.quantity,
          rate: row.rate,
          discount: row.discount,
          tax: row.tax,
          amount: (
            (row.quantity || 0) *
            (row.rate || 0) *
            (1 - (row.discount || 0) / 100) *
            (1 + (row.tax || 0) / 100)
          ).toFixed(2),
        })),
        tax: taxAmountTotal,
        grand_total: subtotal,
        advance_payment: subtotal,
        discount_amount: discountAmountTotal,
        user_id: user.main_id,
        user_name: user.full_name || "Admin",
        main_id: user.main_id,
        due_date: today,
        terms: "custom",
        sendMail: formData.sendMail !== false,
        sendWhatsapp: sendWhatsapp,
      }

      try {
        const response = await fetch(`${url}/receipt/invoice-plus-reciept`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payloadMain)
        })
        const res = await response.json();
        if (response.ok) {
          const { message: deliveryNote, type } = describeReceiptDelivery(res.delivery);
          const base = "Receipt created successfully!";
          if (deliveryNote) {
            if (type === "error") toast.error(`${base} ${deliveryNote}.`);
            else if (type === "warning") toast.warning(`${base} ${deliveryNote}.`);
            else toast.success(`${base} ${deliveryNote}.`);
          } else {
            toast.success(base);
          }
          await fetchReceipts?.();
          await fetchInvoices?.();
          setIsOpen(false);
        } else if (response.status === 403) {
          // Show plan limit exceeded message
          alert(res.message || 'You have reached your receipt submission limit based on your plan.');
        } else {
          alert(res.message || 'Failed to process receipt');
        }
      } catch (error) {
        console.error(error);
        alert('An error occurred while submitting the receipt.');
      } finally {
        setLoad(false)
      }
    } else {
      try {
        const user = getDecryptedUserFromCookie("gta_mainstateuser");
        const payload = {
          ...formData,
          user_id: user.main_id,
          user_name: user.full_name || "Admin",
          main_id: user.main_id,
          sendMail: formData.sendMail !== false,
          sendWhatsapp: sendWhatsapp,
          payment_method: formData.payment_method,
          payment_reference: formData.payment_reference,
        };

        const urlmain = editData
          ? `${url}/receipt/${editData.id}`
          : `${url}/receipt`;
        const method = editData ? 'PUT' : 'POST';

        const response = await fetch(urlmain, {
          method,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (response.ok) {
          const { message: deliveryNote, type } = describeReceiptDelivery(result.delivery);
          const action = editData ? "updated" : "created";
          const base = `Receipt ${action} successfully!`;
          if (deliveryNote) {
            if (type === "error") toast.error(`${base} ${deliveryNote}.`);
            else if (type === "warning") toast.warning(`${base} ${deliveryNote}.`);
            else toast.success(`${base} ${deliveryNote}.`);
          } else {
            toast.success(base);
          }
          await fetchReceipts?.();
          await fetchInvoices?.();
          setIsOpen(false);
        } else if (response.status === 403) {
          // Show plan limit exceeded message
          alert(result.message || 'You have reached your receipt submission limit based on your plan.');
        } else {
          alert(result.message || 'Failed to process receipt');
        }
      } catch (err) {
        console.error('Error submitting receipt:', err);
        alert('An error occurred while submitting the receipt.');
      } finally {
        setLoad(false);
      }
    }
  };


  /** Receipts apply only to invoices that still have balance due (exclude Paid / zero pending). */
  const isInvoiceOpenForReceipt = (inv) => {
    if (!inv) return false;
    if (String(inv.dpstatus || "").toLowerCase() === "draft") return false;
    const pending = parseFloat(inv.pending);
    return Number.isFinite(pending) && pending > 0;
  };

  const fetchInvoicesForAllCustomer = async (customerId) => {
    const key = customerId != null ? String(customerId).trim() : "";
    if (!key || !isLoggedIn?.main_id) {
      setInvoiceData([]);
      return;
    }
    try {
      const response = await fetch(
        `${url}/newinvoice/getinvoice/by-customerId/${encodeURIComponent(key)}/${isLoggedIn.main_id}?unpaidOnly=1`,
        {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      const data = await response.json();
      if (!response.ok) {
        console.error("fetchInvoicesForAllCustomer:", data?.message || response.status);
        setInvoiceData([]);
        return;
      }
      const invoiceDataMain = Array.isArray(data.customer) ? data.customer : [];
      const openInvoices = invoiceDataMain.filter(isInvoiceOpenForReceipt);
      const options = openInvoices.map((inv) => ({
        value: inv.invoice_number,
        label: `${inv.customer_name}-${inv.invoice_number}`,
        pending: inv.pending || 0,
        fullData: inv
      }));
      setInvoiceData(options);
    } catch (error) {
      console.error(error);
      setInvoiceData([]);
    }
  }


  const fetchInvoicesByCustomer = async (customerId) => {
    try {
      const res = await fetch(
        `${url}/newinvoice/by-customer/${customerId}/${isLoggedIn.main_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      const data = await res.json();

      // ✅ normalize response
      const invoices = Array.isArray(data)
        ? data
        : Array.isArray(data.invoices)
          ? data.invoices
          : Array.isArray(data.customer)
            ? data.customer
            : [];

      const options = invoices.map((inv) => ({
        value: inv.invoice_number,
        label: inv.invoice_number,
        invoice: inv
      }));

      setInvoiceOptions(options);
    } catch (err) {
      console.error("Error fetching invoices:", err);
      setInvoiceOptions([]);
    }
  };


  useEffect(() => {
    if (formData.invoiceNumber && invoiceDataget.length > 0) {
      const found = invoiceDataget.find(
        (inv) => inv.value === formData.invoiceNumber
      );
      setSelectedInvoiceMain(found || null);
    }
  }, [formData.invoiceNumber, invoiceDataget]);


  const fetchDatareciept = async () => {
    try {
      const [invoiceRes, orderRes] = await Promise.all([
        fetch(`${url}/newinvoice/next-number/${isLoggedIn.main_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        fetch(`${url}/newinvoice/next-order-number/${isLoggedIn.main_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      const invoiceData = await invoiceRes.json();
      const orderData = await orderRes.json();
      const today = new Date().toLocaleDateString('en-CA');
      // setInvoiceNumberNumeric(invoiceData.invoice_number.replace("INVE", ""));
      setFormData((prev) => ({
        ...prev,
        invoice_Number: invoiceData.invoice_number,
        order_number: orderData.order_number,
        invoice_date: today
      }));
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (isOpen && openInvoice && !editData) {
      fetchDatareciept();
    }
  }, [isOpen, openInvoice, editData]);

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="oms-modal-title">
          {editData ? 'Edit Receipt' : 'Generate Receipt'}
        </h2>
        <form className="oms-modal-form" onSubmit={handleSubmit}>
          <div className="oms-form-group">
            <label className="oms-form-label">Receipt Date</label>
            <input
              type="date"
              name="receiptDate"
              value={formData.receiptDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="oms-form-group">
            <label className="oms-form-label">Customer Name</label>
            <Select
              name="customerName"
              value={customerOptions.find((opt) => String(opt.value) === String(formData.customerId)) || null}
              onChange={(selected) => {
                if (!selected) {
                  // When cleared
                  setFormData((prev) => ({
                    ...prev,
                    customerName: '',
                    customerId: '',
                    invoiceNumber: ''
                  }));
                  setInvoiceOptions([]);
                  setInvoiceData([]);
                  return;
                }
                setFormData((prev) => ({
                  ...prev,
                  customerName: selected.label,
                  customerId: selected.value,
                  invoiceNumber: '' // reset invoice on customer change
                }));
                fetchInvoicesByCustomer(selected.value);
                fetchInvoicesForAllCustomer(selected.value);
              }}

              options={customerOptions}
              placeholder="Select customer"
              isClearable
            />
          </div>


          {
            !openInvoice ? <div className="oms-form-group">
              <div className='displayflexreciept-invoicenumber'>
                <label className="oms-form-label">Invoice Number</label>
                <p onClick={() => {
                  setOpenInvoice(true)
                  setSelectedInvoiceMain(null)
                  fetchDatareciept()
                  setFormData((prev) => ({
                    ...prev,
                    amount: "",
                    invoiceNumber: ''
                  }));

                }}>New Invoice</p>
              </div>
              <Select
                type="text"
                name="invoiceNumber"
                value={invoiceDataget.find((opt) => opt.value === formData.invoiceNumber) || null}
                onChange={(selected) => {
                  if (!selected) {
                    // When cleared
                    setFormData((prev) => ({
                      ...prev,
                      invoiceNumber: ''
                    }));
                    fetchInvoicesForAllCustomer(formData.customerId);
                    setSelectedInvoiceMain(null);
                    return;
                  }
                  setFormData((prev) => ({
                    ...prev,
                    invoiceNumber: selected.value,

                  }));
                  setSelectedInvoice(selected);
                  setSelectedInvoiceMain(selected);
                }}
                options={invoiceDataget}
                placeholder="Enter invoice number"
                isClearable
              />
            </div> : null
          }

          {
            openInvoice ?
              <div>
                <p onClick={() => {
                  setOpenInvoice(false)
                  setSubtotal("")
                  setFormData((prev) => ({
                    ...prev,
                    amount: "",
                  }));
                  setItems([
                    {
                      id: Date.now(), item: null, quantity: "1", rate: "", discount: "", tax: "", amount: 0, discount_amount: 0,
                      tax_amount: 0, hsn: ""
                    },
                  ]);
                }} className='invoiceeightclosebtn-receipt'>Close</p>
                <ItemTable

                  items={items} setItems={setItems} subtotal={subtotal} setSubtotal={setSubtotal} itemsOptions={itemsOptions} setItemsOptions={setItemsOptions}
                  taxAmountTotal={taxAmountTotal}
                  setTaxAmountTotal={setTaxAmountTotal}
                  discountAmountTotal={discountAmountTotal}
                  setDisountamountTotal={setDisountamountTotal}
                />
              </div> : null
          }
          <div className="oms-form-group">
            <label className="oms-form-label">
              {selectedInvoiceMain?.pending != null
                ? `Amount (Balance: ₹${parseFloat(selectedInvoiceMain.pending).toFixed(2)})`
                : 'Amount'}
            </label>
            <input
              type="number"
              name="amount"
              value={formData.amount || subtotal}
              placeholder="Enter amount"
              onChange={(e) => {
                const enteredAmount = parseFloat(e.target.value) || "";
                setFormData((prev) => ({ ...prev, amount: e.target.value }));

                if (selectedInvoiceMain && enteredAmount > parseFloat(selectedInvoiceMain.pending)) {
                  setAmountError(`Amount cannot exceed pending amount ₹${selectedInvoiceMain.pending}`);
                } else {
                  setAmountError('');
                }
              }}
              onWheel={(e) => e.target.blur()}
              required
            />
            {selectedInvoiceMain?.pending != null && (
              <p className={`maininvoice-oms-${amountError ? 'red' : 'green'}`} >
                Remaining Balance: ₹
                {(() => {
                  const pending = parseFloat(selectedInvoiceMain.pending);
                  const entered = parseFloat(formData.amount) || 0;
                  const remaining = pending - entered;
                  return remaining >= 0 ? remaining.toFixed(2) : '0.00';
                })()}
              </p>
            )}
            {amountError && <p style={{ color: 'red', marginTop: '4px' }}>{amountError}</p>}
          </div>

          {!openInvoice ? (
            <>
              <div className="oms-form-group">
                <label className="oms-form-label">Payment method</label>
                <select
                  name="payment_method"
                  value={formData.payment_method || "upi"}
                  onChange={handleChange}
                  required
                >
                  {PAYMENT_METHODS.map((m) => (
                    <option key={m.value} value={m.value}>
                      {m.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="oms-form-group">
                <label className="oms-form-label">Reference (optional)</label>
                <input
                  type="text"
                  name="payment_reference"
                  value={formData.payment_reference || ""}
                  onChange={handleChange}
                  placeholder={
                    REFERENCE_HINTS[formData.payment_method] || "Transaction reference"
                  }
                />
              </div>
            </>
          ) : null}





          <div className="oms-form-group" style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <input
                type="checkbox"
                name="sendMail"
                checked={formData.sendMail !== false}
                onChange={handleChange}
              />
              Email receipt PDF to customer
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                type="checkbox"
                id="sendWhatsapp"
                checked={sendWhatsapp}
                onChange={() => setSendWhatsapp(!sendWhatsapp)}
              />
              Send receipt confirmation via WhatsApp
            </label>
            <p style={{ marginTop: 8, fontSize: 13, color: "#64748b" }}>
              WhatsApp uses customer mobile and AISENSY_RECEIPT_CAMPAIGN_NAME on the server.
            </p>
          </div>

          <div className="oms-form-actions">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              disabled={load}
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={load}
            >
              {load
                ? editData
                  ? "Updating..."
                  : "Generating..."
                : editData
                  ? "Update"
                  : "Generate"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ReceiptModal;
